import { render } from "./HeroiconsOutlineServer.vue?vue&type=template&id=18bc74fe"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineServer.vue"]])

export default __exports__